import * as yup from 'yup'

export default yup.object().shape({
  sensorId: yup.string().min(1).required('Sensor is a required field.'),
  // timestamp: yup
  //   .string()
  //   .length(20, 'timestamp must have a format of: 2019-04-15T11:25:18Z'),
})
